import { Flex } from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { GetLimitedPartnerPortfolioSummaryPgQueryGQLType } from '../../../../types/dashboard-core-gqlTypes.generated.d';
import { LimitedPartnerFiltersFormState } from './LimitedPartnerFiltersDrawer';
import { SkeletonCards, SummaryCard } from './shared';
import { useGetLimitedPartnerPortfolioSummaryPgQuery } from '~/packages/limitedPartners/requests/requests.gql.generated';

const PortfolioSummaryCards = ({
  portfolioSummaryData,
}: {
  portfolioSummaryData: GetLimitedPartnerPortfolioSummaryPgQueryGQLType;
}) => {
  const {
    totalCommittedCapital,
    totalUncalledCapital,
    limitedPartnerCount,
    commitmentCount,
  } = portfolioSummaryData.portfolioSummary;

  return (
    <Flex mt="2.5rem" gap="1.5rem">
      <SummaryCard
        label="Total Commitment Capital"
        value={
          commonUtils.numberToCurrencyWithSymbol({
            number: Number(totalCommittedCapital),
          }) ?? '-'
        }
      />
      <SummaryCard
        label="Total Uncalled Capital"
        value={
          commonUtils.numberToCurrencyWithSymbol({
            number: Number(totalUncalledCapital),
          }) ?? '-'
        }
      />
      <SummaryCard label="Number of LPs" value={String(limitedPartnerCount)} />
      <SummaryCard
        label="Number of LP Commitments"
        value={String(commitmentCount)}
      />
    </Flex>
  );
};

export const LimitedPartnerPortfolioSummaryCards = ({
  lenderOrganizationId,
  activeFilters,
}: {
  lenderOrganizationId: string;
  activeFilters: LimitedPartnerFiltersFormState;
}) => {
  const {
    data: limitedPartnerPortfolioSummaryData,
    error: limitedPartnerPortfolioSummaryError,
  } = useGetLimitedPartnerPortfolioSummaryPgQuery({
    variables: {
      lenderOrganizationId,
      filters: {
        committedCapitalRange: activeFilters.committedCapitalRange,
        uncalledCapitalRange: activeFilters.uncalledCapitalRange,
        netUncalledCapitalRange: activeFilters.netUncalledCapitalRange,
        creditFacilityIds: activeFilters.creditFacilityIds,
      },
    },
  });

  if (limitedPartnerPortfolioSummaryError) {
    throw limitedPartnerPortfolioSummaryError;
  }
  if (!limitedPartnerPortfolioSummaryData) {
    return <SkeletonCards />;
  }
  return (
    <PortfolioSummaryCards
      portfolioSummaryData={limitedPartnerPortfolioSummaryData}
    />
  );
};
